export default "__VITE_ASSET__CPieoB_2__";